import { useEntityAI } from "@/api/useInventory"
import { Empty, Flex, Text } from "@/atoms"
import { useCounts } from "@/organisms/Drawers/hooks/useCounts"

import type { TabComponentProps } from "@/organisms/Drawers/components/TabsDrawerTemplate"

// A workflow's risks: the same empty state as an agent's, until the route serves some
export const RiskTabWorkflowAiDiscoveryDrawer = (props: TabComponentProps) => {
  const recordId = props.record?.id
  const ctx = useEntityAI<KosmosApi.Response<{ title: string }[]>>(
    `${recordId}/risks`,
    "workflow",
    undefined,
    { enabled: !!recordId, retryOnMount: false }
  )
  const risks = ctx.response?.data ?? []

  useCounts("aiRisks", { ...ctx, response: { data: risks } }, props)

  if (!risks.length) return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />

  return (
    <Flex vertical gap={8}>
      {risks.map(({ title }, index) => (
        <Text key={`${title}_${index}`}>{title}</Text>
      ))}
    </Flex>
  )
}
